import { post, read } from '@/utils/request';
import type {
  AccessInfo,
  CurrentUserInfo,
  RegisterInfo,
  FeishuLoginResp,
  ThirdPartyLoginResp,
  ThirdPartyLoginType,
} from '@/typings/user';
import { history } from '@@/core/history';

const queryCurrent = () => {
  return read<CurrentUserInfo>('auth/current_user', undefined, '获取登录状态失败');
};

const transferUserInfo: (currentUser: CurrentUserInfo) => AccessInfo = (currentUser) => {
  const { menus, homeMenu, groups, grayscaleInfos, ...r } = currentUser;
  return {
    ...r,
    roles: groups,
    home: `/${homeMenu?.frontApiName ?? ''}`,
    accessRoutes: menus.map((menu) => `/${menu}`),
    grayscaleInfos,
  } as unknown as AccessInfo;
};

const getUserInfo = async () => {
  const [currentUser] = await queryCurrent();
  if (currentUser) {
    const result = transferUserInfo(currentUser as CurrentUserInfo);
    if (window.location.pathname === '/') {
      history.push(result.home);
    }
    return result;
  }
  history.push(LoginPath);
  return undefined;
};

export type LoginInfo = {
  email: string;
  password: string;
};

const login = (params: LoginInfo) => {
  return post<CurrentUserInfo>('auth/login', params, '登录失败');
};

const logout = () => {
  return read<CurrentUserInfo>('auth/logout', undefined, '退出登录失败');
};

const register = (params: RegisterInfo) => {
  return post('auth/users/add', params, '注册失败');
};

type IModifyPassword = {
  curPassword: string;
  password: string;
  rePassword: string;
};

const modifyPassword = (params: IModifyPassword) => {
  // return post('user/modify_password', params, '修改密码失败')
  return post('auth/users/update-pw', params, '修改密码失败');
};

const feishuLogin = (params: { code: string }) => {
  return post<FeishuLoginResp>('v1/feishu/login', params, '登录失败', undefined, {
    getResponse: true,
  });
};

// 三方登录
const thirdPartyLogin = (params: { code: string; type: ThirdPartyLoginType }) => {
  return post<ThirdPartyLoginResp>('auth/third_login/', params, '登录失败', undefined, {
    isCamel: false,
    isLower: false,
  });
};

export {
  register,
  login,
  logout,
  queryCurrent,
  transferUserInfo,
  getUserInfo,
  modifyPassword,
  feishuLogin,
  thirdPartyLogin,
};
